// extracted by mini-css-extract-plugin
export default {"slogan":"Slogan_slogan__EZE5R"};